import React, { useState } from 'react';
import { useWallet } from '../context/WalletProvider';
import { useToast, readableError } from './Toast';
import { shortAddr } from '../utils/format';

export default function Header() {
  const { address, isConnected, isCorrectNetwork, connect, connecting, ensureNetwork } = useWallet();
  const toast = useToast();
  const [busy, setBusy] = useState(false);

  const onConnect = async () => {
    try {
      setBusy(true);
      await connect();
      toast.success('Wallet connected');
    } catch (e) {
      toast.error(readableError(e));
    } finally {
      setBusy(false);
    }
  };

  const onFix = async () => {
    const ok = await ensureNetwork();
    if (!ok) toast.error('Please switch network in your wallet');
  };

  return (
    <header className="app-header">
      <div className="brand">
        <img src="/logo.png" alt="Zen Capital" />
        <span>ZEN&nbsp;CAPITAL</span>
      </div>

      {!isConnected ? (
        <button className="pill" onClick={onConnect} disabled={busy || connecting}>
          {busy || connecting ? <span className="btn-spin" /> : 'Connect'}
        </button>
      ) : !isCorrectNetwork ? (
        <button className="pill" onClick={onFix} style={{ borderColor: 'var(--down)', color: '#ffb3b8' }}>
          Wrong network · Fix
        </button>
      ) : (
        <span className="pill"><span className="dot" />{shortAddr(address)}</span>
      )}
    </header>
  );
}
